angular.module('autoremind.communications')
    .directive('communicationsTargetRecalls', ['jobService', '$log', function (jobService, $log) {
        return {
            restrict: 'E',
            scope: true,
            templateUrl: 'app/communication/forms/communications-target-recalls.html',
            link: function (scope) {
                // NOTE: scope.jobService is set on parent scope - NOT by injection into this directive
                scope.selectedReasonId = null;
                scope.firstTarget = scope.job.targets[0];
                scope.targetsHasReasonAlready = function () {
                    for (var x in scope.job.targets) {
                        if (scope.job.targets[x].reasonId === scope.selectedReasonId) {
                            return true; // Don't add the same reason twice
                        }
                    }
                    return false;
                };
                /**
                 * Add new target. Ensure that there is either one default (and only one reason) or if other reasons then no default.
                 * These visible targets are added after the first settings target that has no reasonId defined
                 */
                scope.addToTargetGroup = function () {
                    console.log('addToTargetGroup: ' + target);
                    if (!angular.isDefined(scope.selectedReasonId) || scope.selectedReasonId === 'undefined') {
                        return;
                    }
                    if (scope.selectedReasonId === null) {
                        scope.job.targets.splice(1); // Delete all targets after first (settings) target
                    }
                    else {
                        // If first visible target (after settings target) is default then delete that before adding new target
                        if (scope.job.targets.length === 2 && scope.job.targets[1].reasonId === null) {
                            scope.job.targets.splice(1, 1); // Delete target with default reason
                        }
                    }
                    if (!scope.targetsHasReasonAlready(scope.selectedReasonId)) { // Don't add the same reason twice
                        var target = {
                            "type": "recalls",
                            "reasonId": scope.selectedReasonId,
                        };
                        scope.job.targets.push(target);
                    }
                    scope.job.updateTargets();
                };
                scope.updateTargets = function () {
                    scope.job.updateTargets();
                };
            }
        };
    }]);
//# sourceMappingURL=communications-target-recalls.js.map